import { Lesson } from '../../../../types';
const lesson: Lesson = { itemId: '5234449', title: 'Recado Importante', video: { platform: 'youtube', videoId: 'thbAyHFHstI' }, article: [''] };
export default lesson;

